import React, { useEffect, useState } from "react";
import SubscriptionFilters from "./SubscriptionFilters";
import SubscriptionHeading from "./SubscriptionHeading";
import SubscriptionGrid from "./SubscriptionGrid";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";

function SubscriptionMain() {
  const subscriptionModal = useSelector(
    (store) => store.modalToggleSlice.subscriptionCarModal
  );
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  if (subscriptionModal && screenWidth < 640) {
    window.scrollTo(0, 0);
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Monthly Car Rental | Daily, Weekly and Monthly Car Subscription Plans
        </title>
        <meta name="telephone" content="+971523035660" />
        <meta
          name="description"
          content="Looking for monthly car rental plans in the UAE? WTi Car Rental offers flexible car subscription options with no deposit required. Contact us today for the best deals!"
        />
        <meta name="keywords" content="monthly car rental" />

        <meta name="revisit after" content="7 days" />
        <meta name="robots" content="follow, index" />
        <meta name="language" content="English" />
        <meta name="country" content="United Arab Emirates (UAE)" />
        <meta name="copyright" content="WTi Rent A Car LLC" />
        <meta name="publisher" content="wticarrental.ae" />
        <meta name="distribution" content="Global" />

        <link
          rel="canonical"
          href="https://www.wticarrental.ae/monthly car rental"
        />

        <meta
          property="og:title"
          content="Monthly Car Rental | Daily, Weekly and Monthly Car Subscription Plans"
        />
        <meta
          property="og:description"
          content="Looking for a car subscription service in UAE? WTi Car Rental provides the most flexible monthly plans with no deposit. Contact us today for best deals!"
        />
        <meta property="og:image" content="blank" />
        <meta
          property="og:url"
          content="https://www.wticarrental.ae/monthly car rental"
        />
        <script type="application/ld+json">
          {`
{
  "@context": "https://schema.org",
  "@type": "WebPage",
  "url": "https://www.wticarrental.ae/monthly-car-rental",
  "name": "Monthly Car Rental - Hassle-Free Car Subscription Service in Abu Dhabi",
  "description": "WTi Car Rental offers flexible monthly car rental and subscription services in Abu Dhabi. Enjoy a hassle-free, commitment-free driving experience with a wide range of vehicles and customizable terms.",
  "publisher": {
    "@type": "Organization",
    "name": "WTi Car Rental",
    "logo": "https://www.wticarrental.ae/logo.png",
    "sameAs": [
      "https://www.facebook.com/wticarrental",
      "https://www.instagram.com/wticarrental",
      "https://twitter.com/wticarrental"
    ]
  },
  "mainEntityOfPage": "https://www.wticarrental.ae/monthly-car-rental",
  "keywords": "monthly car rental, car subscription, flexible car rental Abu Dhabi, car rental without commitment"
}`}
        </script>

        <script type="application/ld+json">
          {`{
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "WTi Monthly Car Rental",
  "description": "Flexible monthly car rental and subscription services in Abu Dhabi. Rent cars with no long-term commitments, enjoy customizable terms, and drive your dream vehicle hassle-free.",
  "brand": {
    "@type": "Brand",
    "name": "WTi Car Rental"
  },
  "url": "https://www.wticarrental.ae/monthly-car-rental",
  "offers": {
    "@type": "Offer",
    "url": "https://www.wticarrental.ae/monthly-car-rental",
    "priceCurrency": "AED",
    "price": "1500",
    "priceValidUntil": "2025-12-31",
    "eligibleRegion": {
      "@type": "Place",
      "name": "Abu Dhabi"
    },
    "itemOffered": {
      "@type": "Service",
      "name": "Monthly Car Rental Subscription"
    }
  }
}`}
        </script>

        <script type="application/ld+json">
          {`
{
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Suzuki Ciaz Monthly Rental",
  "description": "Suzuki Ciaz available for monthly car rental at AED 1500 per month (VAT Inclusive). Flexible rental terms.",
  "url": "https://www.wticarrental.ae/monthly-car-rental",
  "brand": {
    "@type": "Brand",
    "name": "WTi Car Rental"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "AED",
    "price": "1500",
    "priceValidUntil": "2025-12-31",
    "eligibleRegion": {
      "@type": "Place",
      "name": "Abu Dhabi"
    },
    "itemOffered": {
      "@type": "Product",
      "name": "Suzuki Ciaz Monthly Rental"
    }
  }
}`}
        </script>

        <script type="application/ld+json">
          {`
{
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kaiyi X3 Pro Monthly Rental",
  "description": "Kaiyi X3 Pro available for monthly car rental at AED 1900 per month (VAT Inclusive). Flexible rental terms.",
  "url": "https://www.wticarrental.ae/monthly-car-rental",
  "brand": {
    "@type": "Brand",
    "name": "WTi Car Rental"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "AED",
    "price": "1900",
    "priceValidUntil": "2025-12-31",
    "eligibleRegion": {
      "@type": "Place",
      "name": "Abu Dhabi"
    },
    "itemOffered": {
      "@type": "Product",
      "name": "Kaiyi X3 Pro Monthly Rental"
    }
  }
}`}
        </script>

        <script type="application/ld+json">
          {`
{
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Toyota Yaris or Similar Monthly Rental",
  "description": "Toyota Yaris or similar model available for monthly car rental at AED 1600 per month (VAT Inclusive). Flexible rental terms.",
  "url": "https://www.wticarrental.ae/monthly-car-rental",
  "brand": {
    "@type": "Brand",
    "name": "WTi Car Rental"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "AED",
    "price": "1600",
    "priceValidUntil": "2025-12-31",
    "eligibleRegion": {
      "@type": "Place",
      "name": "Abu Dhabi"
    },
    "itemOffered": {
      "@type": "Product",
      "name": "Toyota Yaris or Similar Monthly Rental"
    }
  }
}`}
        </script>

        <script type="application/ld+json">
          {`
{
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "WTi Car Rental Sharjah",
  "image": "https://www.wticarrental.ae/logo.png",
  "telephone": "+971 50 111 2233",
  "email": "info@wticarrental.ae",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Sharjah",
    "addressRegion": "Sharjah",
    "addressCountry": "AE"
  },
  "url": "https://www.wticarrental.ae/sharjah/rent-a-car-sharjah",
  "description": "Affordable and reliable car rental services in Sharjah. Rent a car for your travels with a wide variety of vehicles available.",
  "priceRange": "$$",
  "openingHours": "Mo-Su 09:00-18:00",
  "sameAs": "https://www.facebook.com/WTiCarRental",
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "25.354706572327437",
    "longitude": "55.42849748531356"
  },
  "paymentAccepted": "Cash, Credit Card, Debit Card",
  "areaServed": "Sharjah, UAE",
  "keywords": "rent a car Sharjah, car rental Sharjah"
}`}
        </script>

        <script type="application/ld+json">
          {`
{
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Rent a Car in Sharjah | WTi Car Rental",
  "url": "https://www.wticarrental.ae/sharjah/rent-a-car-sharjah",
  "description": "Find affordable car rental services in Sharjah with WTi Car Rental. Rent a car for any duration with flexible options.",
  "publisher": {
    "@type": "Organization",
    "name": "WTi Car Rental",
    "logo": "https://www.wticarrental.ae/logo.png"
  },
  "mainEntityOfPage": "https://www.wticarrental.ae/sharjah/rent-a-car-sharjah",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://www.wticarrental.ae/sharjah/rent-a-car-sharjah?q={search_term_string}",
    "query-input": "required name=search_term_string"
  },
  "keywords": "rent a car Sharjah, car rental Sharjah, rent car in Sharjah, affordable car rental services Sharjah"
}
  `}
        </script>
      </Helmet>
      <div
        className={`w-full px-[9.27%] max-sm:px-0 bg-[#FFFFFF] ${
          // subscriptionModal ? "max-sm:h-screen max-sm:overflow-y-hidden" : ""
          subscriptionModal ? "max-sm:overflow-y-hidden" : ""
        }`}
      >
        <SubscriptionFilters />
        <SubscriptionHeading />
        <SubscriptionGrid />

        {/* <PopularBrandsSliderWrapper /> */}
      </div>
    </>
  );
}

export default SubscriptionMain;
